export default {
  products: [],
  highlightedProducts: [],
  productDetails: null,
  isModalOpen: false,
  totalCount: 0,
  productToUpdate: {
    id: null,
    name: '',
    price: '',
    promotionalPrice: '',
    description: '',
    technicalSpecifications: '',
    highlighted: false,
    categoryId: null,
    subCategoryId: null,
    tags: [],
  },
  filters: {
    name: '',
    categoryId: null,
    subCategoryId: null,
    active: null,
    highlighted: null,
    page: 1,
  },

  storeProducts: [],
  storeFilters: {
    categoryId: null,
    subCategoryId: null,
    searchTerm: '',
    orderBy: 'standard',
    page: 1,
  },
  storeTotalCount: 0,
};
